// src/utils.js

/**
 * Converts a string to Title Case (first letter of each word capitalized)
 * @param {string} str - input string
 * @returns {string} - title case string
 */
export const toTitleCase = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};



export const ROLES = {
  SUPER_ADMIN: "1",
};

export const getUserRole = () => {
  return String(localStorage.getItem("role") || "");
};

export const isSuperAdmin = () => {
  return getUserRole() === ROLES.SUPER_ADMIN;
};


export const getUserAccess = () => {
  try {
    const access = localStorage.getItem("access");

    if (!access) {
      return [];
    }

    return JSON.parse(access);
  } catch (error) {
    console.error("Invalid access data:", error);
    return [];
  }
};


// Check whether user has access to a particular menu
export const hasAccess = (menuId) => {
  const access = getUserAccess();

  return access.includes(Number(menuId));
};

export const setUserProfile = (user) => {
    if (!user) return;

    localStorage.setItem(
        "user",
        JSON.stringify(user)
    );

    localStorage.setItem(
        "role",
        String(user.role || "")
    );

    localStorage.setItem(
        "access",
        JSON.stringify(user.access || [])
    );
};